/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:35:55
 * @LastEditTime: 2022-01-24 17:22:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\store\modules\user.js
 */
import {
	login,
	logout,
	getInfo
} from "@/api/user";
import {
	modifyUserPassword
} from "@/api/userDetail";
import {
	getToken,
	setToken,
	removeToken,
	setPreviewUrl2Cookie,
	setCloudUrl2Cookie,
	setOssBucket2Cookie
} from "@/utils/auth";
import {
	resetRouter
} from "@/router";
import storage from "good-storage";
import {
	USER_KEY
} from "@/assets/constant";
import store from "..";

const getDefaultState = () => {
	return {
		token: getToken(),
		name: "",
		avatar: "",
		roles: [],
	};
};

const state = getDefaultState();
var getNewMsgInterval = 0;

const mutations = {
	RESET_STATE: (state) => {
		Object.assign(state, getDefaultState());
	},
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_NAME: (state, name) => {
		state.name = name;
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar;
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles;
	},
};

const actions = {
	/**
	 * 用户修改密码
	 *
	 * @param {*} userInfo
	 * @param passwordPair
	 */
	modifyUserPassword({
		commit
	}, passwordPair) {
		const {
			newPwd,
			rawPwd,
			userId
		} = passwordPair;
		return new Promise((resolve, reject) => {
			modifyUserPassword({
					newPassword: newPwd,
					oldPassword: rawPwd,
					userID: userId
				})
				.then((response) => {
					//console.log("response", response);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				})
		})
	},

	/**
	 * 用户登录
	 *
	 * @param {*} userInfo
	 */
	login({
		commit
	}, userInfo) {
		const {
			username,
			password
		} = userInfo;
		return new Promise((resolve, reject) => {
			login({
					username: username.trim(),
					password: password
				})
				.then((response) => {
					//console.log("response", response);
					if (response.code === 406) {
						console.log(response);
						return;
					}

					// 将用户信息存储到 localStorage 中
					storage.set(USER_KEY, response.data);

					const {
						data
					} = response;
					//console.log(data.token);
					commit("SET_TOKEN", data.token);
					setToken(data.token);
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	/**
	 * 获取用户信息
	 */
	getInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getInfo()
				.then((response) => {
					//console.log(" --------------------------");
					//console.log(".then - response", response);
					//console.log(" --------------------------");
					const {
						data
					} = response;
					if (!data) {
						reject("Verification failed, please Login again.");
					}

					const {
						roleList,
						Nickname,
						Avatar
					} = data;
					const roles = roleList.map((item) => {
						return item.roleName;
					});

					// roles must be a non-empty array
					if (!roles || roles.length <= 0) {
						reject("getInfo: roles must be a non-null array!");
					}

					commit("SET_ROLES", roles);
					commit("SET_NAME", Nickname);
					commit("SET_AVATAR", Avatar);

					if (roles.includes("系统管理员")) {
						getNewMsgInterval = setInterval((function getNewMsg() {
							store.dispatch("newMsg/setExpertAuthenticationNo")
							store.dispatch("newMsg/setConsultationAuthenticationNo")
							return getNewMsg;
						})(), 60000);
					}


					resolve(data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	/**
	 * 用户登出
	 */
	logout({
		commit,
		state
	}) {
		// NOTE 暂时注释下方代码,因为 logout 接口不存在
		// return new Promise((resolve, reject) => {
		// 	logout(state.token)
		// 		.then(() => {
		// 			removeToken(); // must remove token first
		// 			resetRouter();
		// 			commit("RESET_STATE");
		// 			commit("SET_ROLES", "");
		// 			commit("SET_NAME", "");
		// 			commit("SET_AVATAR", "");
		// 			resolve();
		// 		})
		// 		.catch((error) => {
		// 			reject(error);
		// 		});
		// });

		// // NOTE 暂时使用下方代码
		function sleep(delay) {
			return function() {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						resolve();
					}, delay);
				});
			};
		}

		clearInterval(getNewMsgInterval)

		return Promise.resolve()
			.then(sleep(500))
			.then(() => {
				removeToken(); // must remove token first
				resetRouter();
				commit("RESET_STATE");
				commit("SET_ROLES", "");
				commit("SET_NAME", "");
				commit("SET_AVATAR", "");
				store.dispatch("newMsg/setHasNewMsg", false)
			});
	},

	/**
	 * 移除 token
	 */
	resetToken({
		commit
	}) {
		return new Promise((resolve) => {
			removeToken(); // must remove token first
			commit("RESET_STATE");
			resolve();
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
